export default __webpack_public_path__ + "static/media/fashion.0104e9c3.jpg";